// ==================== WHITEPAPERS CONSTANTS ====================
// To publish a new whitepaper: add the PDF and preview images of its first 3 pages to
// src/assets/whitepapers/, import them below and append an entry to WHITEPAPERS.

import conversationsToCustomersPdf from '../assets/whitepapers/AmplifyMsg_Whitepaper.pdf';
import conversationsToCustomersPage1 from '../assets/whitepapers/AmplifyMsg_Whitepaper_page1.webp';
import conversationsToCustomersPage2 from '../assets/whitepapers/AmplifyMsg_Whitepaper_page2.webp';
import conversationsToCustomersPage3 from '../assets/whitepapers/AmplifyMsg_Whitepaper_page3.webp';

export interface WhitepaperPreview {
  src: string;
  /** Page number in the PDF */
  page: number;
  label: string;
}

export interface Whitepaper {
  id: string;
  title: string;
  subtitle: string;
  category: string;
  description: string;
  pages: number;
  /** Display size of the PDF — update when the file is replaced */
  fileSize: string;
  fileUrl: string;
  /** File name the browser saves the download as */
  downloadName: string;
  /** Slides shown in the page preview — exactly the first 3 pages, starting with the cover */
  previewImages: [WhitepaperPreview, WhitepaperPreview, WhitepaperPreview];
  /** Section titles shown under "What's inside" */
  sections: string[];
}

export const WHITEPAPERS: Whitepaper[] = [
  {
    id: 'from-conversations-to-customers',
    title: 'From Conversations to Customers',
    subtitle: 'How to connect WhatsApp, SMS and AI-powered prospecting with AmplifyMsg',
    category: 'Business Messaging & AI Sales Automation',
    description:
      'Customer engagement and new business development often run separately. This whitepaper shows how bringing business messaging and AI-powered prospecting into one platform helps teams organise conversations, find relevant B2B prospects and turn replies into booked meetings.',
    pages: 12,
    fileSize: '24.5 MB',
    fileUrl: conversationsToCustomersPdf,
    downloadName: 'AmplifyMsg - From Conversations to Customers.pdf',
    previewImages: [
      { src: conversationsToCustomersPage1, page: 1, label: 'Cover' },
      { src: conversationsToCustomersPage2, page: 2, label: 'Executive perspective' },
      { src: conversationsToCustomersPage3, page: 3, label: 'The business challenge' },
    ],
    sections: [
      'Executive perspective: connecting conversations with growth',
      'The business challenge: where opportunities lose momentum',
      'The AmplifyMsg approach: one platform, three engines for growth',
      'WhatsApp customer engagement',
      'Your channels, your brand',
      'AI prospect discovery',
      'From outreach to meeting',
      'An example in practice: a B2B services company',
      'Control and visibility over automation',
      'Measuring business value with a focused pilot',
    ],
  },
];
